import React from 'react';
import './App.css';
import CBPChargesMap from './components/CBPChargesMap';

function App() {
  return (
    <div className="App">
      <CBPChargesMap />
    </div>
  );
}

export default App;